import { useQuery } from "@tanstack/react-query";
import { CircularProgress } from "@mui/material";

import { DimensionValueSet } from "@/lib/dimensions";
import { LegendItem } from "@/features/shared/widgets/map/map.styles";
import { legendImageQueryOptions } from "@/features/shared/widgets/map/legends/legend-image-query";

interface LegendImageProps {
  layerId: string;
  opacity?: number;
  loadLegendImage: (dimensionValues: DimensionValueSet) => Promise<Blob | undefined>;
  dimensionValues: DimensionValueSet;
}

const LegendImage = ({
  layerId,
  opacity,
  loadLegendImage,
  dimensionValues,
}: LegendImageProps) => {
  const legendQuery = useQuery({
    ...legendImageQueryOptions(layerId, dimensionValues, loadLegendImage),
    placeholderData: (prev, prevOptions) => {
      if (prevOptions?.queryKey[1] === layerId) return prev;
      return undefined;
    },
    retry: false,
  });

  if (Object.entries(dimensionValues).length === 0) return null;
  if (legendQuery.isError) return <span>Failed to load legend</span>;
  if (legendQuery.isLoading) return <CircularProgress size={24} color="inherit" />;
  if (!legendQuery.data) return null;

  return (
    <LegendItem>
      <img src={legendQuery.data} style={{ opacity: opacity ?? 1.0 }} />
    </LegendItem>
  );
};

export default LegendImage;
